import React from 'react';
import { PictureForm } from '../../../inventory/common';
import {Multilingual, TextInput, LongTextInput, CodeEditor, Modal } from 'hyperdb-utils';
const MultilingualTextInput = Multilingual(TextInput);
const MultilingualLongTextInput = Multilingual(LongTextInput);
const MultilingualCodeEditor = Multilingual(CodeEditor);

const WebsiteTab = ({
  objectData, websiteContent = {}, availableLocales, onChange,
  toggleModalHomepageImage, toggleModalDeleteHomepageImage,
  showModalPicture = false, editedPicture, showModalDeletePicture = false,
  onChangePicture, onUploadPicture, onDeletePicture, uploadingPicture = false, deletingPicture = false,
  defaultLanguage, availableLanguages,
}) => {
  const handleChange = (attributeName, field) => {
    const content = { ...websiteContent };
    content[attributeName] = field.value;
    onChange(content);
  };
  const handleChangeLocalized = (attributeName, field) => {
    const { name, value } = field;
    handleChange(attributeName, { value: { $i18n: value } });
  };
  const localizedValue = (attributeName) => {
    return (websiteContent[attributeName] || {}).$i18n;
  };
  return (
    <fieldset>
      <fieldset>
        <legend>Listing</legend>
          <MultilingualTextInput
            label="Page title"
            name="page_title"
            value={ localizedValue('page_title') }
            onChange={ handleChangeLocalized.bind(null, 'page_title') }
            availableLocales={ availableLocales }
          />
          <MultilingualTextInput
            label="Meta description"
            name="page_meta_description"
            value={ localizedValue('page_meta_description') }
            onChange={ handleChangeLocalized.bind(null, 'page_meta_description') }
            availableLocales={ availableLocales }
          />
          <MultilingualTextInput
            label="Slug"
            name="page_slug"
            value={ localizedValue('page_slug') }
            onChange={ handleChangeLocalized.bind(null, 'page_slug') }
            availableLocales={ availableLocales }
          />
          <MultilingualTextInput
            label="Presentation title"
            name="presentation_title"
            value={ localizedValue('presentation_title') }
            onChange={ handleChangeLocalized.bind(null, 'presentation_title') }
            availableLocales={ availableLocales }
          />
          <MultilingualCodeEditor
            mode="markdown"
            label="Presentation text"
            name="presentation_text"
            value={ localizedValue('presentation_text') }
            onChange={ handleChangeLocalized.bind(null, 'presentation_text') }
            availableLocales={ availableLocales }
          />
      </fieldset>
      <br/><br/>
      <fieldset>
        <legend>Home page</legend>
          <MultilingualTextInput
            label="Short description"
            name="short_description"
            value={ localizedValue('short_description') }
            onChange={ handleChangeLocalized.bind(null, 'short_description') }
            availableLocales={ availableLocales }
          />
          {
            objectData.id
              ? <div>
                  <hr/>
                  <h4>
                    Image
                    &nbsp; {
                      !websiteContent.image
                        ? <button type="button" className="btn btn-primary btn-xs" onClick={toggleModalHomepageImage.bind(null, true)}>Add</button>
                        : null
                    }
                  </h4>
                  {
                    websiteContent.image && websiteContent.image.original
                      ? <div>
                          { websiteContent.image.original.name }
                          &nbsp; <button type="button" className="btn btn-primary btn-xs" onClick={toggleModalHomepageImage.bind(null, true)}>Edit</button>
                          &nbsp; <button type="button" className="btn btn-danger btn-xs" onClick={toggleModalDeleteHomepageImage.bind(null, true)}>Delete</button>
                        </div>
                      : null
                  }
                  {
                    showModalPicture
                      ? <Modal title="" onClose={ toggleModalHomepageImage.bind(null, false) } onAccept={ onUploadPicture } loading={ uploadingPicture }>
                          <PictureForm
                            object={ objectData }
                            picture={ editedPicture }
                            mode="short"
                            backendEntryPoint="/area-contents"
                            onChange={ onChangePicture }
                            uploadingPicture={ uploadingPicture }
                            defaultLanguage={ defaultLanguage }
                            availableLanguages={ availableLanguages }
                          />
                        </Modal>
                      : null
                  }
                  {
                    showModalDeletePicture
                      ? <Modal title="" onClose={ toggleModalDeleteHomepageImage.bind(null, false) } onAccept={ onDeletePicture } loading={ deletingPicture }>
                          Delete this picture ?
                          <br/>
                          { deletingPicture ? 'DELETING...' : '' }
                        </Modal>
                      : null
                  }
                </div>
              : null
          }
      </fieldset>
    </fieldset>
  );
};

export default WebsiteTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/content/area-content/components/WebsiteTab.jsx